import React from 'react'
import "./style.scss"
import { FetchCurrentUserMe } from 'src/generated/graphql'
import Avatar from 'src/components/avatar'
const DEFAULT_PROFILE_PICTURE: string = "/images/default-profile-picture.png"

interface Props {
    authorData: Partial<FetchCurrentUserMe>
}

const Author = ({ authorData }: Props) => {

    return (
        <div className='author-container'>
            <div className="author-img-wrapper">
                <div className='author-img-container'>
                    <Avatar
                        size="author"
                        imageURL={authorData?.avatarUrl || DEFAULT_PROFILE_PICTURE}
                    />
                </div>
                <div>
                    {authorData?.firstName + " " + (authorData?.lastName ?? " ")}
                </div>
            </div>
            <div className='author-detail-container'>
                <div>
                    {authorData?.firstName + " " + (authorData?.lastName ?? " ")}

                </div>

                <div>
                    {authorData?.bio ?? "--"}
                </div>
            </div>
        </div >
    )
}

export default Author